import { format, parse, parseISO } from 'date-fns'

export const fromApiToFormControl = (value: string): string => {
  if (!value) return ''
  const isTime = value.includes('T')
  return isTime
    ? format(parseISO(value), "yyyy-MM-dd'T'HH:mm")
    : format(parse(value, 'dd.MM.yyyy', new Date()), 'yyyy-MM-dd')
}
